export default class Map {
  init() {
      ymaps.ready(function () {
        const obMadData = window.map_data;

        if (obMadData === undefined) {
          return;
        }

        const obMap = new ymaps.Map('map', {
            center: [obMadData.basic_position.lat, obMadData.basic_position.lng],
            zoom: obMadData.basic_position.zoom,
            controls: ['geolocationControl', 'searchControl', 'zoomControl']
          }, {
            searchControlProvider: 'yandex#search'
          });

        let obItem;

        let arIconImageSize = [48, 48];
        let arIconImageOffset = [-23, -45];

        if ($('body').width() <= 1024) {
          arIconImageSize = [60, 60];
          arIconImageOffset = [-30, -57];
        }

        for (let obCityMapData of obMadData.list) {
          obItem = new ymaps.Placemark(
            [obCityMapData.lat, obCityMapData.lng],
            {
              hintContent: obCityMapData.hintContent,
              balloonContent: obCityMapData.balloonContent,
            },
            {
              iconLayout: 'default#image',
              iconImageHref: obCityMapData.iconImageHref,
              iconImageSize: arIconImageSize,
              iconImageOffset: arIconImageOffset
            }
          );
          obMap.geoObjects.add(obItem);
        }

        obMap.behaviors.disable('scrollZoom');
        obMap.events.add('wheel', function (e) {
          document.onkeydown = function (e) {
            if (e.keyCode === 17) {
              obMap.behaviors.enable('scrollZoom');
            }
          };
          document.onkeyup = function (e) {
            if (e.keyCode === 17) {
              obMap.behaviors.disable('scrollZoom');
            }
          };
        });
      });
  }
}
